import {call, put, select} from "redux-saga/effects";
import { SDK } from "../../../sdk";
import {IApplicationState} from "../../index";
import {trackError} from "../../log/actions";
import {LogLevel} from "../../log/types";

let previousScore = 0;

export default function* updateLeaderboardEntry() {
    if (!SDK.instance.supports.leaderboards)
        return;

    const {score, playerName, playerId, language, leaderboardName} = yield select(({ player, settings }: IApplicationState) => ({
        score: player.score,
        playerName: player.name,
        playerId: settings.userId,
        language: settings.general.uiLanguage
    }));

    if (previousScore === score)
       return;

    try {
        yield call([SDK.instance, SDK.instance.setLeaderboardScore], leaderboardName, { 
            playerId,
            playerName,
            score,
            payload: {
                lang: language,
                userId: playerId
            }
        });

        previousScore = score;
    } catch (error) {
        yield put(trackError({
            logLevel: LogLevel.Error,
            category: "SynchronizeState",
            message: "Could not post score to leaderboards",
            error: error,
            data: {
                leaderboardName: leaderboardName
            }
        }));
    }
}